function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    console.log('changes');
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }  
    var size_text_wc = document.querySelector('.size-btn-text-wc').textContent = this.options;
    document.querySelector('.product-form__submit').classList.remove("pick-size-btn-wc");
    console.log(this.currentVariant);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);    
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        const store_availability = html.querySelector('.store-availability-wrapper')?.innerHTML;
        if(store_availability){
          document.querySelector('.store-availability-wrapper').innerHTML = store_availability;
        }
        
        const id = `price-${this.dataset.section}`;
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
       // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if(this.currentVariant != undefined){
      if(this.currentVariant.available){
        document.querySelector('.product-form').classList.remove('variant_sold-out');
      }else{
        document.querySelector('.product-form').classList.add('variant_sold-out');
      }
    }
    
    if (disable) {
      //addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
     // addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class paginationLoadMore extends HTMLElement {
  constructor() {
    super();
    this._loadMoreBtn = this.querySelector(".js-load-more");
    this._destination = this.querySelector("[data-destination]");
    this._nextURL = this.querySelector("[data-next-url]");
    this._totalPages = this.querySelector("[data-total-pages]");
    this._currentPage = this.querySelector("[data-current-page]");    
  }

  connectedCallback() {
   this._loadMoreBtn.addEventListener("click", this._loadMoreProducts.bind(this));
   this.attachAddToCartListeners();
  }

  _loadMoreProducts(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if(this._nextURL.value != '') {

      this._loadMoreBtn.style.cssText = 'display:none';
      this._loadMoreBtn.nextElementSibling.style.cssText = 'display: block';
      fetch(this._nextURL.value)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
         
          this.productResponse = responseHTML.querySelector(this._destination.value);
           console.log(this.productResponse,'this.productResponse');
          this._nextURL.value = responseHTML.querySelector("[data-next-url]").value;
          this._currentPage.value = responseHTML.querySelector("[data-current-page]").value;
          this.previousElementSibling.innerHTML += this.productResponse.innerHTML;
          
         this.attachAddToCartListeners();
        // Update the items seen counter
        const liCount = document.querySelectorAll('#main-collection-product-grid li.grid__item').length;
          if (document.getElementById('item-seen') != null) {
           document.getElementById('item-seen').textContent = `${liCount}`; 
          }

        adjustCardHeights();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

          if(this._totalPages.value <= this._currentPage.value) {
            this._loadMoreBtn.setAttribute('disabled', true);
          }
        })
        .finally(() => {

          this._loadMoreBtn.style.cssText = 'display: inline-block';
          this._loadMoreBtn.nextElementSibling.style.cssText = 'display: none';
          if(this._nextURL.value != '') {
            this._loadMoreBtn.removeAttribute('disabled')
          }
        });
    } else {
      this._loadMoreBtn.setAttribute('disabled', true);
    }
    
    
    
  }
    attachAddToCartListeners() {
    // document.querySelectorAll('#main-collection-product-grid .grid__item').forEach(function(parent) {
    //   parent.querySelectorAll('.add-to-cart-grid-button').forEach(function(child) {
    //     child.addEventListener("click", function(e) {
    //       e.preventDefault();
    //       e.stopImmediatePropagation();

    //       const overlay = document.querySelector('.overlay-box');
    //        const body = document.querySelector('body');
    //       const childHandle = child.getAttribute('data-handle');
    //       const gridItem = child.closest('.grid__item');

    //       parent.querySelectorAll('.size-variant-list').forEach(function(content) {
    //         const contentHandle = content.getAttribute('data-handle');

    //         if (childHandle === contentHandle) {
    //           if (gridItem.classList.contains('active-dot')) {
    //             gridItem.classList.remove('active-dot');
    //             body.classList.remove('active-dot-body');
    //           } else {
    //             parent.querySelectorAll(".grid__item").forEach(function(removeActive) {
    //               removeActive.classList.remove('active-dot');
    //               body.classList.remove('active-dot-body')
    //             });
    //             gridItem.classList.add('active-dot');
    //             body.classList.add('active-dot-body')
    //           }
    //         }
    //       });

    //       overlay.addEventListener('click', function() {
    //         document.querySelectorAll('.grid__item').forEach(function(item) {
    //           item.classList.remove('active-dot');
    //           body.classList.remove('active-dot-body')
    //         });
    //       });
    //     });
    //   });
    // });

  $('.multiple-variant-click').on("click", function(e) {
   console.log("loadmore-click-----------");
    e.preventDefault();
    e.stopImmediatePropagation();
    var $parent = $(this).parents('.grid__item');
    var $overlay = $('.overlay-box');
    var $body = $('body');
    var childHandle = $(this).data('handle');
    var $gridItem = $(this).closest('.grid__item');
    $(this).siblings('.size-variant-list').slideDown();
    $(this).parents('.grid__item').siblings('.grid__item').find('.size-variant-list').slideUp();
    $parent.find('.size-variant-list').each(function() {
      var $content = $(this);
      var contentHandle = $content.data('handle');
    
      if (childHandle === contentHandle) {
        if ($gridItem.hasClass('active-dot')) {
          $gridItem.removeClass('active-dot');
          $body.removeClass('active-dot-body');
        } else {
          $parent.find(".grid__item").each(function() {
            $(this).removeClass('active-dot');
            $body.removeClass('active-dot-body');
          });
          $gridItem.addClass('active-dot');
          $body.addClass('active-dot-body');

          
          $('.size-variant-list ul a').on('click', function(e) {
            if ($(this).attr('href') === '#') {
                e.preventDefault();
                var varid = $(this).find('span').data('id');
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: { id: varid, quantity: 1 },
                    success: function(response) {
                      $('.overlay-box').click();
                        ajaxCart.load();
                        $('body').addClass('CartOpen');
                    }
                });
              }
        })
    
        }
      }
    });
    
    $overlay.on('click', function() {
      $('.grid__item').removeClass('active-dot');
      $body.removeClass('active-dot-body');
      $('.size-variant-list').slideUp();
    });

    


    
    });



      

      
  }
}
customElements.define('pagination-load-more', paginationLoadMore);


$('.collection-filter-list-left h4 a,.mobile-filter-close').on('click', function(e){
e.preventDefault();
$('body').toggleClass('collection-filter-body');
});

document.addEventListener('DOMContentLoaded', function() {
  const liCount = document.querySelectorAll('#main-collection-product-grid li.grid__item').length;
  if (document.getElementById('item-seen') != null) {
   document.getElementById('item-seen').textContent = `${liCount}`; 
  }
  
});


document.addEventListener('DOMContentLoaded', function() {
  window.addEventListener('resize', adjustCardHeights);
  // adjustCardHeights(); // Initial adjustment
});

function adjustCardHeights() {
  const cardTextElements = document.querySelectorAll('.product-title-wc');
  cardTextElements.forEach(el => el.style.height = ''); // Reset heights

  const itemsPerRow = getItemsPerRow();
  let rowElements = [];

  cardTextElements.forEach((cardText, index) => {
    const rowIndex = Math.floor(index / itemsPerRow);
    if (!rowElements[rowIndex]) {
      rowElements[rowIndex] = [];
    }
    rowElements[rowIndex].push(cardText);
  });

  rowElements.forEach(row => {
    const maxHeight = Math.max(...row.map(el => el.offsetHeight));
    row.forEach(el => el.style.height = `${maxHeight}px`);
  });
}

function getItemsPerRow() {
  const screenWidth = window.innerWidth;
  if (screenWidth <= 734) {
    return 2;
  } else if (screenWidth <= 974) {
    return 3;
  } else {
    return 4;
  }
}


document.addEventListener('DOMContentLoaded', function () {
  const clothingTags = document.querySelectorAll('.clothing-tag');
  
  clothingTags.forEach(function (tag) {
    tag.addEventListener('click', function () {
      document.body.classList.add('clothing');
    });
  });
});

$('.multiple-variant-click').on("click", function(e) {
   console.log("multi-click-----------");
    e.preventDefault();
    e.stopImmediatePropagation();
    var $parent = $(this).parents('.grid__item');
    var $overlay = $('.overlay-box');
    var $body = $('body');
    var childHandle = $(this).data('handle');
    var $gridItem = $(this).closest('.grid__item');
    $(this).siblings('.size-variant-list').slideDown();
    $(this).parents('.grid__item').siblings('.grid__item').find('.size-variant-list').slideUp();
    $parent.find('.size-variant-list').each(function() {
      var $content = $(this);
      var contentHandle = $content.data('handle');
    
      if (childHandle === contentHandle) {
        if ($gridItem.hasClass('active-dot')) {
          $gridItem.removeClass('active-dot');
          $body.removeClass('active-dot-body');
        } else {
          $parent.find(".grid__item").each(function() {
            $(this).removeClass('active-dot');
            $body.removeClass('active-dot-body');
          });
          $gridItem.addClass('active-dot');
          $body.addClass('active-dot-body');
          
          $(document).on('click', '.size-variant-list ul a', function(e) {
    if ($(this).attr('href') === '#') {
        e.preventDefault();

        var varid = $(this).find('span').data('id');

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: varid, quantity: 1 },
            success: function(response) {
                $('.overlay-box').click();
                ajaxCart.load();
                $('body').addClass('CartOpen');
            }
        });
    }
});

}
}
});

$overlay.on('click', function() {
  $('.grid__item').removeClass('active-dot');
  $body.removeClass('active-dot-body');
  $('.size-variant-list').slideUp();
});
});
$(document).on('click', '.li-list-desktop', function(e) {
    e.preventDefault(); // stop redirect

    var $this = $(this);
    var varid = $this.find('span').data('id');

    // optional: prevent click if sold out
    if ($this.find('span').hasClass('soldout')) {
        return;
    }

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            id: varid,
            quantity: 1
        },
        success: function(response) {
            console.log('Added to cart:', response);

            // close variant UI
            $('.overlay-box').click();

            // reload cart (your existing function)
            if (typeof ajaxCart !== 'undefined') {
                ajaxCart.load();
            }

            $('body').addClass('CartOpen');
        },
        error: function(err) {
            console.error('Error adding to cart:', err);
        }
    });
});